import React, { useState, useEffect, useRef } from 'react';
import './ToggleInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';
import Toggle from '../Toggle/Toggle';

export default function ToggleInput({ initialValue, label, instructions, name, showError, errorMessage, rules, onValidate }) {
  const [value, setValue] = useState(initialValue ? initialValue : false);
  const valueRef = useRef(initialValue ? initialValue : false);
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);

  if (logComponent('ToggleInput')) { console.debug('ToggleInput rendered'); }

  useEffect(() => {
    if (logComponent('ToggleInput')) { console.debug('ToggleInput onMount'); }
    validateThis();
  }, [])

  const setValueRef = (el) => {
    if (logComponent('ToggleInput')) { console.debug('ToggleInput setValueRef'); }
    setValue(el);
    valueRef.current = el;
  }


  const updateValue = () => {
    if (logComponent('ToggleInput')) { console.debug('ToggleInput updateValue'); }
    let newValue = !valueRef.current;
    setValueRef(newValue);
    validateThis();

  }

  const validateThis = () => {
    if (logComponent('ToggleInput')) { console.debug('ToggleInput validateThis'); }
    var thisValue = valueRef.current;
    let validationDetailsThis = [];
    for (let rule in rules) {
      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](thisValue, rules[rule])
      })
    }

    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);

    setValidationDetails(validationDetailsThis);
    setIsValid(isValidThis);
    

    onValidate({
      name: name,
      isValid: isValidThis,
      value: thisValue
    });
  }  

    return (
      <div className="Toggle-Input-Group">
      {
          showError && !isValid &&
        <p className="Toggle-Input-Group__error">{ errorMessage }</p>
      }         
        <label 
          className="Toggle-Input-Group__label"
          htmlFor={name + '-input'}>
                {label}{
          rules && rules.required &&
          <span className="Toggle-Input-Group__required"> *</span>
}
        </label>
        <Toggle
          selected={value}
          toggleValue={updateValue}
          showTextValue={true}
          trueText="Yes"
          falseText="No"
        />
        { 
          instructions &&
          <span className="Toggle-Input-Group__instructions">{ instructions }</span>
        }
      </div>
    );
}